import ReactDOM from 'react-dom';

function PagePortal({ children }) {
	return ReactDOM.createPortal(children, document.getElementById('page'));
}

export default PagePortal;
